var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3 6C4.12706 6 4.8 5.32706 4.8 4.5C4.8 3.67294 4.12706 3 3.3 3C2.47294 3 1.8 3.67294 1.8 4.5C1.8 5.32706 2.47294 6 3.3 6ZM9.9 3.6H5.7C5.53425 3.6 5.4 3.73425 5.4 3.9V6.6H1.2V2.7C1.2 2.53425 1.06575 2.4 0.9 2.4H0.3C0.13425 2.4 0 2.53425 0 2.7V9.3C0 9.46575 0.13425 9.6 0.3 9.6H0.9C1.06575 9.6 1.2 9.46575 1.2 9.3V8.4H10.8V9.3C10.8 9.46575 10.9343 9.6 11.1 9.6H11.7C11.8658 9.6 12 9.46575 12 9.3V5.7C12 4.54012 11.0599 3.6 9.9 3.6Z",
    fill: "#4A3F2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/bed.fed2dcf2b9a4afd1db88ba3f1cd382e3.svg";
export { ForwardRef as ReactComponent };